import React, {useCallback, useMemo} from 'react';
import {useHistory} from 'react-router-dom';

import {useWeaveflowCurrentRouteContext} from '../../context';
import {useURLSearchParamsDict} from '../util';
import {CompareEvaluationsPage} from './CompareEvaluationsPage';
import {ScoreFilter} from './ecpState';

type CompareEvaluationsPageLoadViewProps = {
  entity: string;
  project: string;
};

export const CompareEvaluationsPageLoadView = ({
  entity,
  project,
}: CompareEvaluationsPageLoadViewProps) => {
  const query = useURLSearchParamsDict();
  const history = useHistory();
  const routerContext = useWeaveflowCurrentRouteContext();

  const evaluationCallIds = useMemo(() => {
    return JSON.parse(query.evaluationCallIds);
  }, [query.evaluationCallIds]);

  const selectedMetrics: Record<string, boolean> | null = useMemo(() => {
    try {
      return JSON.parse(query.metrics);
    } catch (e) {
      return null;
    }
  }, [query.metrics]);

  const scoreFilters: ScoreFilter[] = useMemo(() => {
    try {
      return JSON.parse(query.scoreFilters);
    } catch (e) {
      return [];
    }
  }, [query.scoreFilters]);

  const onEvaluationCallIdsUpdate = useCallback(
    (newEvaluationCallIds: string[]) => {
      history.push(
        routerContext.compareEvaluationsUri(
          entity,
          project,
          newEvaluationCallIds,
          selectedMetrics,
          scoreFilters
        )
      );
    },
    [history, entity, project, routerContext, selectedMetrics, scoreFilters]
  );

  const setSelectedMetrics = useCallback(
    (newModel: Record<string, boolean>) => {
      history.push(
        routerContext.compareEvaluationsUri(
          entity,
          project,
          evaluationCallIds,
          newModel,
          scoreFilters
        )
      );
    },
    [history, entity, project, routerContext, evaluationCallIds, scoreFilters]
  );

  const setScoreFilters = useCallback(
    (newFilters: ScoreFilter[]) => {
      history.push(
        routerContext.compareEvaluationsUri(
          entity,
          project,
          evaluationCallIds,
          selectedMetrics,
          newFilters
        )
      );
    },
    [
      history,
      entity,
      project,
      routerContext,
      evaluationCallIds,
      selectedMetrics,
    ]
  );

  return (
    <CompareEvaluationsPage
      entity={entity}
      project={project}
      evaluationCallIds={evaluationCallIds}
      onEvaluationCallIdsUpdate={onEvaluationCallIdsUpdate}
      selectedMetrics={selectedMetrics}
      setSelectedMetrics={setSelectedMetrics}
      scoreFilters={scoreFilters}
      setScoreFilters={setScoreFilters}
    />
  );
};
